import React from 'react';

import { fg } from '@atlassian/jira-feature-gating';

import { TryHomeDashboardsBanner } from './try-home-dashboards-banner/index.tsx';
import { ActivateHomeDashboardsBanner } from './activate-home-dashboards-banner/index.tsx';

/**
 * Shows different content based on feature flags and can be dismissed.
 */

export const EngagementBanners: React.FC = () => {
	return (
		<>
			<>{fg('endeavour_home_dashboard_banner') ? <ActivateHomeDashboardsBanner /> : null}</>
			<>
				{fg('endeavour_home_dashboard_activated_banner_text') ? <TryHomeDashboardsBanner /> : null}
			</>
		</>
	);
};
